import { render } from "./UnitsList.vue?vue&type=template&id=48c85532&scoped=true"
import script from "./UnitsList.vue?vue&type=script&lang=js"
export * from "./UnitsList.vue?vue&type=script&lang=js"

import "./UnitsList.vue?vue&type=style&index=0&id=48c85532&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c85532"]])

export default __exports__